<template>
  <div class="tree-item-list" v-if="pagingList.length">
    <div
      v-for="item in pagingList"
      :key="item[valueKey]"
      @click="selectTreeItemClick(item)"
      :class="{
        'selected-item': isSelectedItem(item),
        'virtual-department-or-selectable': disabledFunc(item),
        'has-sub':
          item.hasChildrenDepartments && !item.hideChildrenDepartments && item.childrenList && item.childrenList.length,
        'virtual-department-or-selectable-no-checked': disabledFunc(item) && item.childrenList.length,
      }"
      v-if="!useEntity || !item.hideDepartment"
      class="tree-item half-px-border"
    >
      <div class="department-checkbox">
        <svg-icon :type="isSelectedItem(item) ? 'circle-check' : 'circle-un-check'" class="new-checkbox-image active" />
      </div>
      <div class="department-checkbox-disable">
        <svg-icon type="circle-disable-un-check" class="new-checkbox-image" />
      </div>
      <div class="tree-item-name">
        <slot name="name" :item="item"></slot>
      </div>
      <div
        v-if="
          item.hasChildrenDepartments && !item.hideChildrenDepartments && item.childrenList && item.childrenList.length
        "
        @click.stop="spreadTreeItem(item)"
        class="tree-item-sub"
      >
        {{ $t('commonForm-1.key113', { cm: '下级' }) }}
        <img :src="images.arrow" class="arrow-image" />
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">

import checkboxBlank from '@/assets/images/helios-pay/unchecked.png';
import checkboxBlankDisable from '@/assets/images/common/checkbox-blank-disable@2x.png';
import arrow from 'assets/images/application/travel/arrow-right@3x.png';
import DepartmentItem from 'src/components/base-ui-v3/select-department/department-item.vue';

export default {
  name: 'tree-item-list',
  props: {
    pagingList: {
      type: Array,
      default: []
    },
    selectTreeItem: {
      type: Function
    },
    spreadTreeItem: {
      type: Function
    },
    curSelectedResults:{
      type: Array,
      default: []
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    useEntity: {
      type: Boolean,
      default: false
    },
    disabledFunc:{
      type:Function,
      default:function (){
        return function (){
          return false;
        };
      }
    },
    vuexConfig:{
      type:Object,
      default:()=>{
        return {};
      }
    }
  },
  components:{
    DepartmentItem
  },
  data() {
    return {
      images: {
        checkboxBlank,
        checkboxBlankDisable,
        arrow
      },
    };
  },
  computed: {
  },
  methods: {
    selectTreeItemClick(item) {
      this.selectTreeItem(item);
    },
    isSelectedItem(selected) {
      return this.curSelectedResults.some(item => item[this.valueKey] === selected[this.valueKey]);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~assets/css/variable.scss';

.tree-item-list {
  margin-bottom: px(10);

  .tree-item {
    position: relative;
    background: #fff;
    min-height: px(88);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: px(16) px(10) px(16) px(80);
    cursor: pointer;
    &.selected-item {
      //background: $lightColor;
    }
    &:last-of-type:after {
      display: none;
    }
    &.has-sub {
      .checkbox-image {
        right: px(140);
        padding-right: px(30);
        border-right: 2px solid #d7dce6;
      }
      .tree-item-name {
        max-width: calc(100% - #{px(202)});
      }
    }
    &.virtual-department-or-selectable {
      //background: #f2f2f2;
      background: white;
      .department-name {
        //color: #999;
      }
      .department-checkbox {
        display: none;
      }
      .department-checkbox-disable {
        display: block;
      }
    }
    &.virtual-department-or-selectable-no-checked {
      .department-checkbox-disable {
        display: none;
      }
    }
    .delete-icon {
      width: 32px;
      height: 32px;
      border: 4px solid $mainColor;
      border-radius: px(20);
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      &:after {
        content: '';
        width: 12px;
        height: 4px;
        background: $mainColor;
      }
    }

    .department-checkbox,
    .department-checkbox-disable {
      width: px(32);
      height: px(32);
      position: absolute;
      left: px(28);
      top: 50%;
      margin-top: px(-20);

      .new-checkbox-image {
        font-size: 32px;
        &.active {
          color: $mainColor;
        }
      }
    }

    .department-checkbox-disable {
      display: none;
    }

    .tree-item-sub {
      font-size: px(24);
      padding: px(18);
      color: #969aa2;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;

      .arrow-image {
        width: px(24);
        height: px(24);
        margin-left: px(10);
      }
    }

    .checkbox-image {
      width: px(32);
      height: px(32);
      position: absolute;
      right: px(28);
      top: 50%;
      margin-top: px(-16);
    }
  }
}
</style>
